var render = function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}},[_c('path',{attrs:{"fill":"#DE3C4B","fill-rule":"evenodd","d":"M8.707 13.485l.707-.707L17.9 4.293a1 1 0 011.415 1.414l-8.486 8.485 8.486 8.486a1 1 0 01-1.415 1.414l-8.485-8.485-.707-.708a1 1 0 010-1.414z"}})]) };
module.exports = { render: render };


//////////////////
// WEBPACK FOOTER
// ./assets/_img/icons/back.svg
// module id = 314
// module chunks = 0